import AudioPlayer from "../../../../components/AudioPlayer/AudioPlayer";
import "./ChatBubble.scss";

interface ChatBubbleProps {
  content: string;
  textColor?: string;
  tailSide?: "left" | "right";
  audioUri?: string; // optional URL of conversation audio
  stopAudio?: boolean; // external command to stop playback
}

interface TextPart {
  value: string;
  isHighlight: boolean;
}

/**
 * Parses `{highlighted}` segments from raw conversation content
 * (mirrors the mobile CustomChatBubble regex).
 */
function parseHighlights(raw: string): TextPart[] {
  const parts: TextPart[] = [];
  const regex = /\{(.*?)\}/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = regex.exec(raw)) !== null) {
    if (m.index > last) {
      parts.push({ value: raw.substring(last, m.index), isHighlight: false });
    }
    parts.push({ value: m[1], isHighlight: true });
    last = regex.lastIndex;
  }
  if (last < raw.length) {
    parts.push({ value: raw.substring(last), isHighlight: false });
  }
  return parts;
}

function ChatBubble({
  content,
  textColor,
  tailSide = "left",
  audioUri,
  stopAudio,
}: ChatBubbleProps) {
  if (!content?.trim()) return null;

  const parts = parseHighlights(content);

  return (
    <div className={`chat-bubble chat-bubble--tail-${tailSide}`}>
      <p
        className="chat-bubble__text"
        style={textColor ? { color: textColor } : undefined}
      >
        {parts.map((p, i) =>
          p.isHighlight ? (
            <span key={i} className="chat-bubble__highlight">
              {p.value}
            </span>
          ) : (
            <span key={i}>{p.value}</span>
          ),
        )}
      </p>

      {audioUri && (
        <div className="chat-bubble__audio">
          <AudioPlayer uri={audioUri} stopAudio={stopAudio} autoPlay />
        </div>
      )}
    </div>
  );
}

export default ChatBubble;
